resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    Button

    Button extends the functionality of the existing button to allow state management.

    HTML Structure:
        A <button> with data-mogo-ui variable set to "Button"

        E.g;

            button.btn.primary(data-mogo-ui="Button" type="submit" data-mogo-ui-label="Label")

    Arguments:
        label [string]:
            The button label.
        state (optional) [string]:
            The default state of the button. If undefined, it is set to "initial".
            Other possible states are:
                loading
                    shows a progress indicator on the button
                disabled
                    disables the button
    Methods:
        setState(state)
            arguments: state
            changes button state to the state value specified
        resetState()
            arguments: none
            resets state of the button to "initial"
        setLoadState()
            arguments: none
            changes button state to "loading"
        removeLoadState()
            arguments: none
            changes button state from "loading" to "initial"
        setDisabledState()
            arguments: none
            changes button state to "disabled" and disables the button
        removeDisabledState()
            arguments: none
            changes button state from "disabled" to "initial".
        setDisabledLoadingState()
            arguments: none;
            changes button state to disabled and loading
        removeDisabledLoadingState()
            arguments: none;
            resets state of the button to "initial"
        setInitialState()
            arguments: none
            resets state of the button to "initial"
        getCurrentStatus()
            arguments: none
            returns the current state of the button

*/
function Button () {
  this.extends = [];
  this.node = null;
  this.id = null;
  this.label = 'Default Label';
  this.state = null;

  this._states = {
    initial: 'initial',
    loading: 'loading',
    disabled: 'disabled',
    disabledLoading: 'loading'
  };
  this._statesClassMap = {
    initial: 'button-initial',
    disabled: 'button-disabled',
    loading: 'button-loading',
    disabledLoading: 'button-loading'
  };

  this.init = function () {
    this.state ? this.setState(this.state) : this.setState(this._states.initial);
  };

  this.initAllReady = function () {
    $(this.node).append(this._getTemplate());
    $(this.node).addClass('data-mogo-ui-button');
    $('span.label', this.node).text(this.label);
  };

  this.setState = function (state) {
    if (this._states.hasOwnProperty(state)) {
      this._setCurrentState(this.state);
      switch (state) {
        case this._states.loading:
          this.setLoadState();
          break;
        case this._states.disabled:
          this.setDisabledState();
          break;
        case this._states.disabledLoading:
          this.setDisabledLoadingState();
          break;
        default:
          this.setInitialState();
          break;
      }
    }
  };

  this.resetState = function () {
    this.setInitialState();
  };

  this.setLoadState = function () {
    this._removeCurrentState();
    this._setCurrentState(this._states.loading);
    $(this.node).addClass(this._statesClassMap.loading);
  };

  this.removeLoadState = function () {
    $(this.node).removeClass(this._statesClassMap.loading);
    this.setInitialState();
  };

  this.setDisabledState = function () {
    this._removeCurrentState();
    this._setCurrentState(this._states.disabled);
    $(this.node).addClass(this._statesClassMap.disabled);
    $(this.node).prop('disabled', true);
  };

  this.removeDisabledState = function () {
    this._setCurrentState(this._states.initial);
    this.setInitialState();
    $(this.node).removeClass(this._statesClassMap.disabled);
    $(this.node).prop('disabled', false);
  };

  this.setDisabledLoadState = function () {
    this._removeCurrentState();
    this._setCurrentState(this._states.disabledLoading);
    $(this.node).addClass(this._statesClassMap.disabledLoading);
    $(this.node).prop('disabled', true);
  };

  this.removeDisabledLoadState = function () {
    this._setCurrentState(this._states.initial);
    this.setInitialState();
    $(this.node).removeClass(this._statesClassMap.disabledLoading);
    $(this.node).prop('disabled', false);
  };

  this.setInitialState = function () {
    this._removeCurrentState();
    this._setCurrentState(this._states.initial);
    $(this.node).addClass(this._statesClassMap.initial);
  };

  this.getCurrentState = function () {
    return this._currentState;
  };

  this._setCurrentState = function (newState) {
    this._currentState = newState;
  };

  this._removeCurrentState = function () {
    var state = this.getCurrentState();
    $(this.node).removeClass(this._statesClassMap[state]);
    this._currentState = null;
  };

  this._getTemplate = function () {
    return '<span class="label"></span>' + '<span class="progress-infinite"></span';
  };
}
